/* Standard configurators only. Keep the existing controls, calculators and order methods intact. */
(() => {
  if (window.FibroluxCutWizard) { window.FibroluxCutWizard.init(document); return; }
  const instances = new WeakMap();
  const words = {
    de: { steps: ['Produkt', 'Maße & Mengen', 'Ergebnis'], headings: ['Welches Produkt möchten Sie zuschneiden?', 'Welche Maße benötigen Sie?', 'Ihr Zuschnitt im Überblick'], next: ['Weiter zu den Maßen', 'Ergebnis anzeigen'], back: 'Zurück', edit: 'Produkt ändern', imported: 'Ihre Vorauswahl wurde übernommen.', busy: 'Wird berechnet …', select: 'Bitte wählen Sie das Produkt und die gewünschten Eigenschaften aus.', dimensions: 'Bitte geben Sie für jede Zeile gültige Maße und eine ganze Menge ab 1 ein.', failed: 'Die Berechnung ist gerade nicht möglich. Bitte versuchen Sie es erneut.', nav: 'Zuschnitt konfigurieren', selection: 'Ihre Auswahl' },
    en: { steps: ['Product', 'Sizes & quantities', 'Result'], headings: ['Which product would you like to cut?', 'What sizes do you need?', 'Your cutting overview'], next: ['Continue to sizes', 'Show result'], back: 'Back', edit: 'Change product', imported: 'Your previous selection has been applied.', busy: 'Calculating …', select: 'Please select a product and its properties.', dimensions: 'Please enter valid sizes and a whole quantity of at least 1 in every row.', failed: 'We could not calculate this right now. Please try again.', nav: 'Configure cutting', selection: 'Your selection' },
    fr: { steps: ['Produit', 'Dimensions & quantités', 'Résultat'], headings: ['Quel produit souhaitez-vous découper ?', 'Quelles dimensions souhaitez-vous ?', 'Votre découpe en un coup d’œil'], next: ['Passer aux dimensions', 'Voir le résultat'], back: 'Retour', edit: 'Modifier le produit', imported: 'Votre présélection a été reprise.', busy: 'Calcul en cours …', select: 'Veuillez choisir un produit et ses caractéristiques.', dimensions: 'Saisissez des dimensions valides et une quantité entière d’au moins 1 pour chaque ligne.', failed: 'Le calcul est momentanément indisponible. Veuillez réessayer.', nav: 'Configurer la découpe', selection: 'Votre sélection' },
    es: { steps: ['Producto', 'Medidas y cantidades', 'Resultado'], headings: ['¿Qué producto desea cortar?', '¿Qué medidas necesita?', 'Resumen de su corte'], next: ['Continuar a medidas', 'Ver resultado'], back: 'Atrás', edit: 'Cambiar producto', imported: 'Se ha aplicado su selección previa.', busy: 'Calculando …', select: 'Seleccione un producto y sus características.', dimensions: 'Introduzca medidas válidas y una cantidad entera de al menos 1 en cada fila.', failed: 'No se puede calcular en este momento. Inténtelo de nuevo.', nav: 'Configurar corte', selection: 'Su selección' },
    it: { steps: ['Prodotto', 'Misure e quantità', 'Risultato'], headings: ['Quale prodotto desidera tagliare?', 'Di quali misure ha bisogno?', 'Riepilogo del taglio'], next: ['Continua alle misure', 'Mostra risultato'], back: 'Indietro', edit: 'Cambia prodotto', imported: 'La preselezione è stata applicata.', busy: 'Calcolo in corso …', select: 'Selezioni un prodotto e le sue caratteristiche.', dimensions: 'Inserisca misure valide e una quantità intera di almeno 1 per ogni riga.', failed: 'Il calcolo non è disponibile al momento. Riprovi.', nav: 'Configura il taglio', selection: 'La sua selezione' },
    pl: { steps: ['Produkt', 'Wymiary i ilości', 'Wynik'], headings: ['Jaki produkt chcesz przyciąć?', 'Jakich wymiarów potrzebujesz?', 'Podsumowanie cięcia'], next: ['Przejdź do wymiarów', 'Pokaż wynik'], back: 'Wstecz', edit: 'Zmień produkt', imported: 'Wcześniejszy wybór został zachowany.', busy: 'Obliczanie …', select: 'Wybierz produkt i jego właściwości.', dimensions: 'W każdym wierszu podaj poprawne wymiary i całkowitą ilość co najmniej 1.', failed: 'Obliczenie nie jest teraz możliwe. Spróbuj ponownie.', nav: 'Konfiguracja cięcia', selection: 'Twój wybór' }
  };
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text) el.textContent = text;
    return el;
  };
  const button = (text, className = '') => {
    const el = node('button', className, text); el.type = 'button'; return el;
  };
  class Wizard {
    constructor(owner) {
      this.owner = owner;
      this.t = words[String(owner.config.language || document.documentElement.lang || 'de').slice(0, 2)] || words.de;
      this.step = 1; this.visited = 1; this.busy = false; this.attempted = false;
      this.product = owner.profileSelect || owner.productSelect;
      this.form = owner.querySelector('[class$="__panel--form"]');
      this.summary = owner.querySelector('[class$="__panel--summary"]');
      this.grid = this.form?.parentElement;
      if (!this.form || !this.summary || !this.product || !owner.rowsContainer || !owner.optionFields) return;
      this.build();
      instances.set(owner, this);
      this.bind();
      this.restoreEntry();
    }
    build() {
      const o = this.owner;
      this.shell = node('div', 'cut-wizard');
      this.grid.before(this.shell);
      const modes = o.querySelector('.fibrolux-cut-modes');
      if (modes) this.shell.append(modes);
      this.nav = node('nav', 'cut-wizard__nav');
      this.nav.setAttribute('aria-label', this.t.nav);
      this.tabs = this.t.steps.map((label, i) => {
        const b = button('', 'cut-wizard__step'); b.dataset.cutWizardGo = String(i + 1);
        const n = node('span', 'cut-wizard__number', String(i + 1)); n.setAttribute('aria-hidden', 'true');
        b.append(n, node('span', '', label));
        b.setAttribute('aria-controls', `${o.id}-wizard-${i + 1}`);
        this.nav.append(b); return b;
      });
      this.shell.append(this.nav, this.grid);
      this.panels = [1, 2, 3].map((step, i) => {
        const panel = node('section', 'cut-wizard__panel');
        panel.id = `${o.id}-wizard-${step}`;
        panel.dataset.cutWizardPanel = String(step);
        const title = node('h3', 'cut-wizard__title', this.t.headings[i]);
        title.id = `${panel.id}-title`; title.tabIndex = -1;
        panel.setAttribute('aria-labelledby', title.id); panel.append(title);
        return panel;
      });
      const [product, dimensions, result] = this.panels;
      this.imported = node('p', 'cut-wizard__imported', this.t.imported);
      this.imported.hidden = true; product.append(this.imported);
      product.append(this.product.parentElement, o.optionFields);
      this.contexts = [dimensions, result].map(panel => {
        const context = node('div', 'cut-wizard__selection');
        const text = node('p');
        const edit = button(this.t.edit, 'cut-wizard__link'); edit.dataset.cutWizardGo = '1';
        context.setAttribute('aria-label', this.t.selection); context.append(text, edit); panel.append(context); return text;
      });
      const units = o.querySelector('.fibrolux-cut-units');
      if (units) dimensions.append(units);
      dimensions.append(o.rowsContainer.parentElement);
      const edge = o.edgeModeSelect?.closest('.gitterrost-cut-configurator__dimensions')?.parentElement;
      if (edge) dimensions.append(edge);
      for (const selector of ['[data-delivery-preference]', '[data-parcel-offcuts]']) {
        const choice = o.querySelector(selector); if (choice) result.append(choice);
      }
      const columns = node('div', 'cut-wizard__result-columns');
      const planColumn = node('div', 'cut-wizard__plan-column');
      const priceColumn = node('div', 'cut-wizard__price-column');
      const preview = o.bar || o.preview;
      if (preview) planColumn.append(preview);
      if (o.printButton) planColumn.append(o.printButton);
      if (o.deliveryKicker?.parentElement) priceColumn.append(o.deliveryKicker.parentElement);
      priceColumn.append(o.summary, o.addCartButton.parentElement);
      columns.append(planColumn, priceColumn); this.summary.append(columns);
      result.append(this.summary);
      const notice = o.querySelector('.cut-configurator__notice');
      if (notice) result.append(notice);
      // Retain the actual nodes and their listeners, including the shared error and add-to-cart controls.
      this.form.append(product, dimensions);
      this.grid.append(result);
      this.feedback = node('div', 'cut-wizard__feedback');
      this.error = node('p', 'cut-wizard__error'); this.error.hidden = true;
      this.error.setAttribute('role', 'alert');
      this.feedback.append(this.error, o.message);
      o.message.setAttribute('role', 'status');
      this.footer = node('div', 'cut-wizard__actions');
      this.back = button(`← ${this.t.back}`, 'cut-wizard__link');
      this.next = button(this.t.next[0], 'button cut-wizard__next');
      this.footer.append(this.back, this.next);
      this.shell.append(this.feedback, this.footer);
      o.dataset.cutWizard = 'true';
      this.labelOptions();
    }
    bind() {
      this.shell.addEventListener('click', event => {
        const target = event.target.closest('[data-cut-wizard-go]');
        if (target && !target.disabled) this.go(Number(target.dataset.cutWizardGo));
      });
      this.back.addEventListener('click', () => this.go(this.step - 1));
      this.next.addEventListener('click', () => this.go(this.step + 1));
      const edit = event => {
        if (!event.target.matches('input, select') || this.busy) return;
        this.error.hidden = true;
        if (this.step < 3) { this.visited = Math.min(this.visited, 2); this.attempted = false; }
        this.labelOptions(); this.sync();
      };
      this.owner.addEventListener('input', edit);
      this.owner.addEventListener('change', edit);
      this.owner.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('input[type="number"]') && this.step === 2) {
          event.preventDefault(); this.go(3);
        }
      });
      this.observer = new MutationObserver(() => { this.labelOptions(); this.syncMessage(); });
      this.observer.observe(this.owner.optionFields, { childList: true, subtree: true });
      this.observer.observe(this.owner.message, { childList: true, subtree: true });
      // Reopening an existing plan is an entry flow, not a fresh wizard. Never replace the plan loader.
      if (typeof this.owner.loadPlan === 'function') {
        const load = this.owner.loadPlan;
        this.owner.loadPlan = (...args) => {
          const loaded = load.apply(this.owner, args);
          if (loaded) this.restoreEntry(true);
          return loaded;
        };
      }
    }
    labelOptions() {
      this.owner.optionFields.querySelectorAll('[data-option-filter]').forEach(select => {
        const label = select.previousElementSibling;
        if (label?.tagName !== 'LABEL') return;
        const id = select.id || `${this.owner.id}-option-${select.dataset.optionFilter}`;
        if (select.id !== id) select.id = id;
        if (label.htmlFor !== id) label.htmlFor = id;
      });
    }
    productValid() {
      return [this.product, ...this.owner.optionFields.querySelectorAll('select')].every(select =>
        select.value !== '' && select.selectedOptions.length && !select.selectedOptions[0].disabled);
    }
    invalidDimension() {
      const rows = [...this.owner.rowsContainer.querySelectorAll('[data-row]')];
      if (!rows.length) return this.owner.addRowButton;
      for (const row of rows) {
        for (const input of row.querySelectorAll('[data-length], [data-width], [data-quantity]')) {
          const quantity = input.hasAttribute('data-quantity');
          const value = quantity ? Number(input.value) : window.FibroluxCutUnits.toMillimetres(input);
          if (input.value === '' || !Number.isFinite(value) || !Number.isInteger(value) || value < 1 || !input.checkValidity()) return input;
        }
      }
      return null;
    }
    restoreEntry(planLoaded = false) {
      this.labelOptions();
      const params = new URLSearchParams(window.location.search);
      const entry = planLoaded || params.has('product') || params.has('plan') || params.get('source') === 'stock-suggestion';
      this.imported.hidden = !entry || !this.product.value;
      const complete = this.productValid();
      // Product-only links (e.g. ISO 38) keep all unselected properties visible in step 1.
      const replay = planLoaded || params.has('plan');
      const step = this.owner.result && (replay || (complete && !this.invalidDimension())) ? 3 : complete ? 2 : 1;
      this.show(step, false);
    }
    async go(step) {
      if (this.busy || step < 1 || step > 3 || this.owner.addCartButton.classList.contains('loading')) return;
      this.error.hidden = true;
      if (step <= this.step) { this.show(step); return; }
      if (!this.productValid()) {
        this.show(1, false); this.fail(this.t.select, [this.product, ...this.owner.optionFields.querySelectorAll('select')].find(el => !el.value || el.selectedOptions[0]?.disabled)); return;
      }
      if (step === 2) { this.show(2); return; }
      const invalid = this.invalidDimension();
      if (invalid) { this.show(2, false); this.fail(this.t.dimensions, invalid); return; }
      this.busy = true; this.attempted = true;
      const controls = [...this.owner.querySelectorAll('button, input, select')];
      const disabled = controls.map(el => el.disabled);
      controls.forEach(el => { el.disabled = true; });
      this.next.textContent = this.t.busy; this.next.classList.add('is-loading');
      this.shell.setAttribute('aria-busy', 'true');
      try {
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        // Restore controls BEFORE the original calculation, which owns add-to-cart availability.
        controls.forEach((el, i) => { el.disabled = disabled[i]; });
        if (!this.owner.isConnected) return;
        this.owner.calculate();
        if (this.owner.result && !this.owner.addCartButton.disabled) this.show(3);
        else { this.show(2, false); this.owner.message.scrollIntoView({ block: 'nearest', behavior: 'auto' }); }
      } catch (error) {
        this.fail(this.t.failed);
      } finally {
        this.busy = false; this.next.classList.remove('is-loading');
        this.shell.removeAttribute('aria-busy'); this.sync();
      }
    }
    fail(text, input) {
      this.error.textContent = text; this.error.hidden = false;
      input?.focus({ preventScroll: true });
      (input || this.error).scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }
    show(step, focus = true) {
      this.step = step; this.visited = Math.max(this.visited, step);
      this.sync();
      if (focus) {
        const heading = this.panels[step - 1].querySelector('h3');
        heading.focus({ preventScroll: true });
        this.nav.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    }
    sync() {
      this.owner.dataset.cutWizardStep = String(this.step);
      this.panels.forEach((panel, i) => { panel.hidden = i + 1 !== this.step; });
      this.form.hidden = this.step === 3;
      this.tabs.forEach((tab, i) => {
        if (i + 1 === this.step) tab.setAttribute('aria-current', 'step');
        else tab.removeAttribute('aria-current');
        tab.disabled = i + 1 > this.visited;
      });
      this.back.hidden = this.step === 1;
      this.next.hidden = this.step === 3;
      if (!this.busy) this.next.textContent = this.t.next[Math.min(this.step - 1, 1)];
      const selected = [this.product, ...this.owner.optionFields.querySelectorAll('select')]
        .filter(select => select.value !== '').map(select => select.selectedOptions[0]?.textContent.trim()).filter(Boolean).join(' · ');
      this.contexts.forEach(context => { context.textContent = selected; });
      this.syncMessage();
    }
    syncMessage() {
      const message = this.owner.message;
      // Routine “enter dimensions” prompts belong to step 2; genuine validation/cart errors remain visible.
      message.hidden = !message.textContent.trim() || (this.step < 3 && !this.attempted);
    }
  }
  function init(scope) {
    const roots = [...scope.querySelectorAll('.fibrolux-zuschnitt--finder-ui')];
    if (scope.matches?.('.fibrolux-zuschnitt--finder-ui')) roots.unshift(scope);
    roots.forEach(root => {
      root.querySelectorAll('cut-configurator, gitterrost-cut-configurator').forEach(owner => {
        if (instances.has(owner)) return;
        customElements.whenDefined(owner.localName).then(() => {
          if (owner.isConnected && owner.config && !instances.has(owner)) new Wizard(owner);
        });
      });
    });
  }
  window.FibroluxCutWizard = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
